import React, { useEffect } from 'react';

import { ChooseService as ChooseServiceView } from './choose-service';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { EcpServices } from '../ecp-locator.models';
import { ecpStoresCached } from '../../../../../graphql/ecp-locator/ecp-locator.cache';
import { EcpProfileResponse } from '../../../../../graphql/ecp-locator/models';

export const ChooseService = ({
  isFitted,
  ecpProfile,
  isLoading,
}: { isFitted?: boolean, ecpProfile?: EcpProfileResponse, isLoading: boolean }): JSX.Element => {

  const isCv = ecpProfile?.profile?.servicesAvailability?.controlVisitAvailability ?? false;
  const isAec = ecpProfile?.profile?.servicesAvailability?.annualEyeCheckAvailability ?? false;
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect((): void => {
    ecpStoresCached([]);
  }, []);

  useEffect((): void => {
    const source = searchParams.get('source');
    searchParams.set('ecpService', EcpServices.fit);
    const newSearchParams = searchParams.toString();

    if (source === 'ozon') {
      navigate(`${location.pathname}?${newSearchParams}`, { replace: true });
    }
  }, [location, navigate, searchParams]);

  return (
    <ChooseServiceView
      isCv={isCv}
      isAec={isAec}
      isFitted={!!isFitted}
      isLoading={isLoading}
    />
  );
};
